// src/menu/sections/ipamMenu.ts
import type { AppMenuEntry } from "../types";

export const IPAM_MENU: AppMenuEntry = {
  type: "group",
  key: "ipam",
  label: "IPAM",
  children: [
    {
      key: "vrfs",
      label: "VRFs",
      path: "/vrfs",
      resource: "vrfs",
      icon: "branches",
    },
    {
      key: "ipamcontrol",
      label: "IPAM Control",
      path: "/ipamcontrol",
      componentKey: "ipamcontrol",
      icon: "apartment",
    },
    /*
    {
      key: "ip_addresses",
      label: "IP Addresses",
      path: "/ip_addresses",
      resource: "ip_addresses",
      icon: "ipam",
    },
    {
      key: "prefixes",
      label: "Prefixes",
      path: "/prefixes",
      resource: "prefixes",
      icon: "ipam",
    },
*/
  ],
};
